import React, { useState, useEffect, useRef } from 'react'

import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

import Title from './Title'

const validateEmail = email => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    ? true
    : false
}

const Email = props => {
  const emailRef = useRef('')
  const [required, setRequired] = useState()
  const [focused, setFocused] = useState(false)
  const [changed, setChanged] = useState(false)
  const [incomplete, setIncomplete] = useState(false)

  useEffect(() => {
    setRequired(props.required)
    setChanged(false)
  }, [props.required])

  const validateField = () => {
    props.onSetValid(validateEmail(emailRef.current.value))
  }

  const onFocus = e => {
    setFocused(true)
    setChanged(false)
    setIncomplete(false)
  }

  const onBlur = e => {
    setFocused(false)
    if (emailRef.current.value === '') {
      if (changed) setRequired(true)
      setIncomplete(false)
    } else {
      setRequired(false)
      setIncomplete(!validateEmail(emailRef.current.value))
    }
    validateField()
    props.onBlur(emailRef.current.value)
  }

  const onChange = e => {
    setRequired(false)
    setIncomplete(false)
    setChanged(true)
    validateField()
  }

  return (
    <Form.Group className='mb-3' controlId='Email'>
      <Title title='Email' required={required} />
      <InputGroup>
        <Form.Control
          style={{
            borderColor: !focused && (required || incomplete) && 'red'
          }}
          ref={emailRef}
          name='email'
          type='email'
          onFocus={onFocus}
          onChange={onChange}
          onBlur={onBlur}
          disabled={props.disabled}
        />
        {incomplete && (
          <i
            style={{
              color: 'red',
              position: 'absolute',
              padding: '7px',
              right: 6
            }}
            className='float-end bi-exclamation-circle'
          ></i>
        )}
      </InputGroup>
      {incomplete && (
        <Form.Text style={{ color: 'red' }}>
          Your email is incomplete.
        </Form.Text>
      )}
    </Form.Group>
  )
}

export default Email
